<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.acctType"
        placeholder="账户类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in acctTypeList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <!-- <el-button
        class="filter-item"
        type="primary"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
        @click="handleExport"
        >导出</el-button
      > -->
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="id" align="center" prop="id"></el-table-column>
      <el-table-column
        label="变更金额"
        align="center"
        prop="amount"
      ></el-table-column>
      <el-table-column label="业务类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getStatus(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center" prop="ctdate">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
        prop="remark"
      ></el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout=" prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import DataPicker from "@/views/components/dataPicker.vue";
import { uploadXlsx } from "@/utils/index";
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";
import { getTbcAcctFlow, exportWithdrawApplyList } from "@/api/account-profit";

const SHOP_STATUS = [
  {
    key: 1,
    value: "消费获得",
  },
  {
    key: 2,
    value: "抽奖获得",
  },
  {
    key: 3,
    value: "直推获得",
  },
  {
    key: 4,
    value: "间推获得",
  },
  {
    key: 5,
    value: "级差奖",
  },
  {
    key: 6,
    value: "平级奖励",
  },
  {
    key: 7,
    value: "充值",
  },
  {
    key: 8,
    value: "提现",
  },
  {
    key: 9,
    value: "支付",
  },
  {
    key: 10,
    value: "转出",
  },
  {
    key: 11,
    value: "转入",
  },
  {
    key: 12,
    value: "兑换",
  },
  {
    key: 13,
    value: "释放转出",
  },
  {
    key: 14,
    value: "释放转入",
  },
  {
    key: 15,
    value: "协议变更",
  },
  {
    key: 16,
    value: "买入",
  },
  {
    key: 17,
    value: "买出",
  },
  {
    key: 18,
    value: "平台赠送",
  },
  {
    key: 19,
    value: "区域代理收益",
  },
  {
    key: 20,
    value: "分红收益",
  },
  {
    key: 21,
    value: "退款",
  },
  {
    key: 22,
    value: "预分配",
  },
  {
    key: 23,
    value: "释放抽奖次数消耗",
  },
  {
    key: 24,
    value: "抽奖消耗",
  },
  {
    key: 25,
    value: "加速释放转出",
  },
  {
    key: 26,
    value: "下级消费业绩",
  },
  {
    key: 27,
    value: "下级退货扣除奖励",
  },
  {
    key: 28,
    value: "代理商分润",
  },
  {
    key: 29,
    value: "代理商提现",
  },
  {
    key: 30,
    value: "代理商分润冻结",
  },
  {
    key: 31,
    value: "代理商取消提现",
  },
  {
    key: 32,
    value: "代理商TBC奖励",
  },
  {
    key: 33,
    value: "退货退款扣除代理商TBC奖励",
  },
  {
    key: 34,
    value: "TBC总资金池奖励",
  },
  {
    key: 35,
    value: "TBC发展基金资金池奖励",
  },
];
export default {
  name: "profitSharingOrder",
  props: {
    agentUserId: {
      type: Number || String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      total: null,
      listLoading: true,
      acctTypeList: [
        {
          key: "lock",
          value: "锁定账户",
        },
        {
          key: "current",
          value: "活期账户",
        },
      ],
      listQuery: {
        page: 1,
        pageSize: 10,
        acctType: "current",
        // keyword: "",
        // status: ""
      },
      statusMap: new Map(SHOP_STATUS.map((item) => [item.key, item.value])),
      isAgentLogin: "",
    };
  },
  mounted() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = false;
      getTbcAcctFlow(this.listQuery).then((res) => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleExport() {
      exportWithdrawApplyList(this.listQuery).then((res) => {
        console.log(res);
        uploadXlsx(res, "账户分润订单表");
      });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "order") {
        this.listQuery.orderStartTime = value[0];
        this.listQuery.orderEndTime = value[1];
      }
      if (type === "receiving") {
        this.listQuery.deliveryStartTime = value[0];
        this.listQuery.deliveryEndTime = value[1];
      }
    },
    getStatus(key) {
      return this.statusMap.get(key);
    },
  },
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    },
  },
  components: {
    DataPicker,
  },
};
</script>
